import { render, staticRenderFns } from "./lossManage.vue?vue&type=template&id=85041c00&scoped=true"
import script from "./lossManage.vue?vue&type=script&lang=js"
export * from "./lossManage.vue?vue&type=script&lang=js"
import style0 from "./lossManage.vue?vue&type=style&index=0&id=85041c00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85041c00",
  null
  
)

export default component.exports